import {h, Fragment} from "preact"
import { useAppState } from "@nosto/preact"
import { useEffect, useState } from "preact/hooks"

import Loader from "./elements/Loader"
import Toolbar from "./Toolbar"
import Sidebar from "./Sidebar"
import Products from "./Products"
import LoadMore from "./LoadMore"
import NoResults from "./NoResults"

export default function Serp() {
    const { response: { products }, loading } = useAppState();
    const foundProducts = products && products.total > 0;
    const [ facetsOpen, setFacetsOpen ] = useState(false);
    const [ mobileColumns, setMobileColumns ] = useState("2");
    const [ desktopColumns, setDesktopColumns ] = useState("2");

    useEffect(() => {
        (window.innerWidth < 750 && facetsOpen)
            ?   document.querySelector('body').classList.add('overflow-hidden')
            :   document.querySelector('body').classList.remove('overflow-hidden')
            
        return () => document.querySelector('body').classList.remove('overflow-hidden')
    }, [ facetsOpen ])

    const changeGridColumns = (event) => {
        (window.innerWidth > 990)
            ?   setDesktopColumns(event.target.value)
            :   setMobileColumns(event.target.value)
    }

    const toggleFacets = () => {
        setFacetsOpen(prevFacetsOpen => !prevFacetsOpen)
    }

    return (
        <div class="ns-serp">
            {(foundProducts) ? (
                <>
                    <Sidebar 
                        facetsOpen={facetsOpen}
                        toggleFacets={toggleFacets}
                    />
                    <div class="ns-serp-inner page-width">
                        <Toolbar 
                            facetsOpen={facetsOpen}
                            toggleFacets={toggleFacets}
                            changeGridColumns={changeGridColumns}
                        />
                        <Products 
                            mobileColumns={mobileColumns}
                            desktopColumns={desktopColumns}
                        />
                        <LoadMore />
                    </div>
                </>
            ) : (loading) ? (
                <Loader />
            ) : (
                <NoResults />
            )}
        </div>
    )
}
